var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"tabbar-header is-block-mobile"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:{
        active: _vm.isActive(index),
        disabled: tab.disabled,
        'is-hidden-mobile': !_vm.isActive(index) && _vm.showMenu,
      },on:{"click":function($event){return _vm.select(index)}}},[_vm._v(" "+_vm._s(tab.label)+" "),(_vm.isActive(index))?_c('span',{staticClass:"is-hidden-tablet"},[_vm._v("▼")]):_vm._e()])}),0),_c('div',{staticClass:"tabbar-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }